import styled from 'styled-components';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsPaginationWrapper = styled<any, any>('div')`
    ${propStyles};
`;

DocumentsPaginationWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'md',
};

export default DocumentsPaginationWrapper;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsPaginationWrapper.tsx